// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconSonic } from "../../../icons/full/build/icon-sonic.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const SonicIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconSonic.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  SonicIcon.displayName = 'SonicIcon';
}

export default SonicIcon;